import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const listCode =
`<List>
    <ListItem selected>
        <ListItemGraphic icon={<AccountIcon />} />
        <ListItemText>Janet Perkins</ListItemText>
    </ListItem>
    <ListItem>
        <ListItemGraphic icon={<AccountIcon />} />
        <ListItemText>Mary Johnson</ListItemText>
    </ListItem>
    <ListItem>
        <ListItemGraphic icon={<AccountIcon />} />
        <ListItemText>Peter Carlsson</ListItemText>
    </ListItem>
</List>`;

const listDemo = {
    code: listCode
};

export const ListDemo: FunctionComponent = () => {
    return (
        <Demo demo={listDemo}>
            <ComponentProps componentName="List" />
            <ComponentProps componentName="ListItem" />
            <ComponentProps componentName="ListItemText" />
            <ComponentProps componentName="ListItemGraphic" />
            <ComponentProps componentName="ListItemDivider" />
            <ComponentProps componentName="ListItemGroup" />
            <ComponentProps componentName="ListItemSubheader" />
        </Demo>
    );
};

const treeListCode =
`<TreeList>
    <TreeListItem label="Alloy Meet">
        <TreeListItem label="Meet 1" />
        <TreeListItem label="Meet 2" />
        <TreeListItem label="Meet 3" />
    </TreeListItem>
</TreeList>`;

const treeListDemo = {
    code: treeListCode
};

export const TreeListDemo: FunctionComponent = () => {
    return (
        <Demo demo={treeListDemo}>
            <ComponentProps componentName="TreeList" />
            <ComponentProps componentName="TreeListItem" />
        </Demo>
    );
};
